import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import KeyValueLabel from '../../labels/KeyValueLabel/KeyValueLabel';
import StatusLabel from '../../labels/StatusLabel/StatusLabel';
import InfoSign from '../../InfoSign/InfoSign';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeTimesheet, timesheetsStatuses } from '../../../../utils/constants';
import classes from './HeaderWithStatus.module.scss';
import InfoIcon from '../../Icons/InfoIcon';
import MainButton from '../../buttons/MainButton';
import { buttonVariants } from '../../buttons/types';
import { FileDownloadOutlined } from '@mui/icons-material';

export default function HeaderWithStatus({
  data,
  leftContent,
  keyValueLabel = [],
  actionsContainer,
  isApprover,
  hasChanges,
  exportHandler
}) {
  const size = useWindowSize();
  const [t] = useTranslation();

  const isActionButtonLogicVisible = () => {
    const { approved, rejected, processed } = timesheetsStatuses(t);

    if (
      (!isApprover && [approved.apiStatus].includes(data?.Status?.Status)) ||
      (isApprover && [rejected.apiStatus].includes(data?.Status?.Status)) ||
      [processed.apiStatus].includes(data?.Status?.Status)
    ) {
      return false;
    }

    return true;
  };

  return (
    <div className={classes.container}>
      {leftContent}
      <div className={classes.rightContainer}>
        <div className={`${isApprover ? classes.statusApproverWrapper : classes.statusWrapper} !items-center`}>
          {[timesheetsStatuses(t).processed.apiStatus].includes(data.Status.Status) && size.width > responsiveSizeTimesheet && (
            <MainButton
              size="small"
              variant={buttonVariants.SECONDARY}
              outlined
              rounded
              action={exportHandler}
              forceWidth={size.width > responsiveSizeTimesheet ? 'fit-content' : '100%'}
              sx={{
                marginRight: '20px'
              }}
            >
              <div className="flex items-center gap-1 justify-center">
                <FileDownloadOutlined />
                <span>{t('common.general.export')}</span>
              </div>
            </MainButton>
          )}
          {(size.width > responsiveSizeTimesheet ||
            (size.width < responsiveSizeTimesheet && hasChanges) ||
            (size.width < responsiveSizeTimesheet &&
              ![timesheetsStatuses(t).draft.apiStatus].includes(data.Status.Status))) && (
            <InfoSign
              text={
                isApprover && size.width > responsiveSizeTimesheet && `${data?.User?.FirstName} ${data?.User?.LastName}`
              }
              icon={<InfoIcon />}
            >
              <Box
                sx={{
                  width: 'max-content',
                  padding: '32px 24px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  gap: '14px',
                  backgroundColor: '#F6F7F9',
                  boxShadow: size.width > responsiveSizeTimesheet ? '0 4px 4px rgba(0, 0, 0, 0.25)' : 'none',
                  borderRadius: '20px'
                }}
              >
                {keyValueLabel?.map((item) => {
                  return <KeyValueLabel key={item?.label} label={item?.label} value={item?.value} />;
                })}
              </Box>
            </InfoSign>
          )}
          <KeyValueLabel
            label=""
            value={
              <StatusLabel
                type={data?.Status?.Status.toLowerCase()}
                text={data?.Status?.Status}
                isApprover={isApprover}
              />
            }
          />
        </div>
        {isActionButtonLogicVisible() && actionsContainer}
      </div>
    </div>
  );
}
